/**
 * Construye un FormData para enviar al backend
 * @param {Object} formPrincipal - Datos principales de la landing
 * @param {Array} hipervinculos - Lista de hipervínculos
 * @param {Array} contactos - Lista de contactos
 * @param {Array} preguntasFrecuentes - Lista de preguntas frecuentes
 * @param {number} landingId - ID de la landing (opcional, para edición)
 * @returns {FormData}
 */
export const buildFormData = (formPrincipal, hipervinculos, contactos, preguntasFrecuentes, landingId = null) => {
    const formData = new FormData();

    // ID para edición
    if (landingId) {
        formData.append('id', landingId);
    }

    // Datos principales
    formData.append('nombre', formPrincipal.nombre);
    formData.append('cliente', formPrincipal.cliente?.code || '');
    formData.append('contenido', formPrincipal.contenido || '');
    formData.append('activo', formPrincipal.activo);

    // Imagen principal (tipo 1)
    if (formPrincipal.imagen instanceof File) {
        formData.append('imagenPrincipal', formPrincipal.imagen);
    }

    // Sección Principal - Tipo 1
    const seccionPrincipal = {
        tipo: 1,
        datos: {
            nombre: formPrincipal.nombre,
            cliente: formPrincipal.cliente?.code,
            contenido: formPrincipal.contenido,
            activo: formPrincipal.activo
        }
    };
    formData.append('secciones[0]', JSON.stringify(seccionPrincipal));

    // Sección Hipervínculos - Tipo 2
    const seccionHipervinculos = {
        tipo: 2,
        datos: hipervinculos.map((hv, index) => ({
            id: hv.id || null, // Incluir ID si existe (para edición)
            orden: index + 1,
            titulo: hv.titulo,
            contenido: hv.contenido,
            hipervinculo: hv.hipervinculo,
            activo: hv.activo,
            imagenKey: hv.imagen instanceof File ? `hipervinculo_${index}` : null,
            imagenExistente: typeof hv.imagen === 'string' ? hv.imagen : null
        }))
    };
    formData.append('secciones[1]', JSON.stringify(seccionHipervinculos));

    // Adjuntar imágenes de hipervínculos
    hipervinculos.forEach((hv, index) => {
        if (hv.imagen instanceof File) {
            formData.append(`imagenHipervinculo_${index}`, hv.imagen);
        }
    });

    // Sección Contacto - Tipo 3
    const seccionContacto = {
        tipo: 3,
        datos: contactos.map((ct, index) => ({
            id: ct.id || null, // Incluir ID si existe (para edición)
            orden: index + 1,
            titulo: ct.titulo,
            contenido: ct.contenido,
            hipervinculo: ct.hipervinculo,
            activo: ct.activo,
            imagenKey: ct.imagen instanceof File ? `contacto_${index}` : null,
            imagenExistente: typeof ct.imagen === 'string' ? ct.imagen : null
        }))
    };
    formData.append('secciones[2]', JSON.stringify(seccionContacto));

    // Adjuntar imágenes de contactos
    contactos.forEach((ct, index) => {
        if (ct.imagen instanceof File) {
            formData.append(`imagenContacto_${index}`, ct.imagen);
        }
    });

    // Sección Preguntas Frecuentes - Tipo 4
    const seccionPreguntas = {
        tipo: 4,
        datos: preguntasFrecuentes.map(pf => ({
            id: pf.id || null, // Incluir ID si existe (para edición)
            pregunta: pf.pregunta,
            respuesta: pf.respuesta
        }))
    };
    formData.append('secciones[3]', JSON.stringify(seccionPreguntas));

    return formData;
};

/**
 * Muestra el contenido del FormData en consola para debugging
 * @param {FormData} formData
 */
export const logFormData = (formData) => {
    // for (let [key, value] of formData.entries()) {
    //     if (value instanceof File) {
    //         console.log(`${key}:`, {
    //             name: value.name,
    //             size: value.size,
    //             type: value.type
    //         });
    //     } else {
    //         console.log(`${key}:`, value);
    //     }
    // }
};
